import { useState, useEffect } from 'react';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white shadow-xl py-4'
          : 'bg-white/90 backdrop-blur-sm py-6'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between">
          <button
            onClick={scrollToTop}
            className="flex items-center gap-3 cursor-pointer group"
          >
            <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
              <i className="ri-bug-line text-2xl text-white"></i>
            </div>
            <span className="text-2xl font-black text-gray-900 group-hover:text-teal-600 transition-colors">
              L.J. Boydston
            </span>
          </button>

          <div className="flex items-center gap-2">
            <button
              onClick={() => scrollToSection('book')}
              className="px-6 py-3 rounded-full text-base font-bold transition-all hover:scale-105 whitespace-nowrap cursor-pointer text-gray-700 hover:bg-teal-50 hover:text-teal-600"
            >
              📚 Books
            </button>
            <button
              onClick={() => scrollToSection('book-video')}
              className="px-6 py-3 rounded-full text-base font-bold transition-all hover:scale-105 whitespace-nowrap cursor-pointer text-gray-700 hover:bg-teal-50 hover:text-teal-600"
            >
              🎬 Video
            </button>
            <button
              onClick={() => scrollToSection('author')}
              className="px-6 py-3 rounded-full text-base font-bold transition-all hover:scale-105 whitespace-nowrap cursor-pointer text-gray-700 hover:bg-teal-50 hover:text-teal-600"
            >
              ✍️ Author
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="px-6 py-3 rounded-full text-base font-bold transition-all hover:scale-105 whitespace-nowrap cursor-pointer text-gray-700 hover:bg-teal-50 hover:text-teal-600"
            >
              💌 Contact
            </button>
            <a
              href="https://www.amazon.com/March-Ants-L-J-Boydston/dp/1969865253/ref=sr_1_3?dib=eyJ2IjoiMSJ9.azebjqgrJvD2tJYp4FhromrOoSglaQ6YH6554-TBtizKMAupPXEjh-5pNNlQCPIf.82nf9cbaBtObFr-RnuADz4PvTiQ-DRXf5uj--dYS0lc&dib_tag=se&qid=1769006752&refinements=p_27%3AL+J+Boydston&s=books&sr=1-3&text=L+J+Boydston"
              target="_blank"
              rel="noopener noreferrer"
              className="ml-2 bg-gradient-to-r from-teal-500 to-teal-600 text-white px-6 py-3 rounded-full text-base font-bold hover:from-teal-600 hover:to-teal-700 transition-all hover:scale-110 hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-amazon-fill mr-2"></i>
              Shop Now
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
